/**
 * Backend i18n codes - Auto-generated file
 * 
 * ⚠️ WARNING: Do not modify manually
 * Generated by: pnpm gen:backend-i18n
 * Source: /v1/i18n/queryAllI18n
 */

export const BACKEND_I18N_CODES = [
  // t('backend-i18n:@administrationMethod')
  '@administrationMethod',
  // t('backend-i18n:@admissionDateTime')
  '@admissionDateTime',
  // t('backend-i18n:@admissionMethod')
  '@admissionMethod',
  // t('backend-i18n:@age')
  '@age',
  // t('backend-i18n:@allergyHistory')
  '@allergyHistory',
  // t('backend-i18n:@attendingPhysicianCode')
  '@attendingPhysicianCode',
  // t('backend-i18n:@attendingPhysicianName')
  '@attendingPhysicianName',
  // t('backend-i18n:@bedNumber')
  '@bedNumber',
  // t('backend-i18n:@billingCategory')
  '@billingCategory',
  // t('backend-i18n:@birthDate')
  '@birthDate',
  // t('backend-i18n:@bloodType')
  '@bloodType',
  // t('backend-i18n:@chiefComplaint')
  '@chiefComplaint',
  // t('backend-i18n:@clinicRoomName')
  '@clinicRoomName',
  // t('backend-i18n:@clinicRoomNumber')
  '@clinicRoomNumber',
  // t('backend-i18n:@contactHomePhone1')
  '@contactHomePhone1',
  // t('backend-i18n:@contactHomePhone2')
  '@contactHomePhone2',
  // t('backend-i18n:@contactMobilePhone1')
  '@contactMobilePhone1',
  // t('backend-i18n:@contactMobilePhone2')
  '@contactMobilePhone2',
  // t('backend-i18n:@copaymentCode')
  '@copaymentCode',
  // t('backend-i18n:@currentUser')
  '@currentUser',
  // t('backend-i18n:@days')
  '@days',
  // t('backend-i18n:@departmentCode')
  '@departmentCode',
  // t('backend-i18n:@departmentName')
  '@departmentName',
  // t('backend-i18n:@dischargeDateTime')
  '@dischargeDateTime',
  // t('backend-i18n:@doctor')
  '@doctor',
  // t('backend-i18n:@doctorLicenseNumber')
  '@doctorLicenseNumber',
  // t('backend-i18n:@doctorSpecialty')
  '@doctorSpecialty',
  // t('backend-i18n:@dosage')
  '@dosage',
  // t('backend-i18n:@dosageUnit')
  '@dosageUnit',
  // t('backend-i18n:@educationLevel')
  '@educationLevel',
  // t('backend-i18n:@encounterCategory')
  '@encounterCategory',
  // t('backend-i18n:@encounterDateTime')
  '@encounterDateTime',
  // t('backend-i18n:@encounterNumber')
  '@encounterNumber',
  // t('backend-i18n:@encounterSequenceNumber')
  '@encounterSequenceNumber',
  // t('backend-i18n:@executionEndDateTime')
  '@executionEndDateTime',
  // t('backend-i18n:@executionStartDateTime')
  '@executionStartDateTime',
  // t('backend-i18n:@familyMember')
  '@familyMember',
  // t('backend-i18n:@frequency')
  '@frequency',
  // t('backend-i18n:@gender')
  '@gender',
  // t('backend-i18n:@homePhone')
  '@homePhone',
  // t('backend-i18n:@id')
  '@id',
  // t('backend-i18n:@identityDocumentType')
  '@identityDocumentType',
  // t('backend-i18n:@institutionAddress')
  '@institutionAddress',
  // t('backend-i18n:@institutionCode')
  '@institutionCode',
  // t('backend-i18n:@institutionName')
  '@institutionName',
  // t('backend-i18n:@institutionPhone')
  '@institutionPhone',
  // t('backend-i18n:@mailingAddress')
  '@mailingAddress',
  // t('backend-i18n:@marriage')
  '@marriage',
  // t('backend-i18n:@medicalDepartment')
  '@medicalDepartment',
  // t('backend-i18n:@mobilePhone')
  '@mobilePhone',
  // t('backend-i18n:@mrn')
  '@mrn',
  // t('backend-i18n:@name1')
  '@name1',
  // t('backend-i18n:@name2')
  '@name2',
  // t('backend-i18n:@nurse')
  '@nurse',
  // t('backend-i18n:@occupation')
  '@occupation',
  // t('backend-i18n:@orderCategory')
  '@orderCategory',
  // t('backend-i18n:@orderCode')
  '@orderCode',
  // t('backend-i18n:@orderDateTime')
  '@orderDateTime',
  // t('backend-i18n:@orderId')
  '@orderId',
  // t('backend-i18n:@orderName')
  '@orderName',
  // t('backend-i18n:@patientCategory')
  '@patientCategory',
  // t('backend-i18n:@patientName')
  '@patientName',
  // t('backend-i18n:@paymentPercentage')
  '@paymentPercentage',
  // t('backend-i18n:@performer')
  '@performer',
  // t('backend-i18n:@primaryDiagnosisCode')
  '@primaryDiagnosisCode',
  // t('backend-i18n:@primaryDiagnosisName')
  '@primaryDiagnosisName',
  // t('backend-i18n:@primaryProcedureCode')
  '@primaryProcedureCode',
  // t('backend-i18n:@primaryProcedureName')
  '@primaryProcedureName',
  // t('backend-i18n:@relationship1')
  '@relationship1',
  // t('backend-i18n:@relationship2')
  '@relationship2',
  // t('backend-i18n:@religion')
  '@religion',
  // t('backend-i18n:@requisitionNumber')
  '@requisitionNumber',
  // t('backend-i18n:@responsiblePerson')
  '@responsiblePerson',
  // t('backend-i18n:@route')
  '@route',
  // t('backend-i18n:@secondaryDiagnosisCode')
  '@secondaryDiagnosisCode',
  // t('backend-i18n:@secondaryDiagnosisName')
  '@secondaryDiagnosisName',
  // t('backend-i18n:@secondaryProcedureCode')
  '@secondaryProcedureCode',
  // t('backend-i18n:@secondaryProcedureName')
  '@secondaryProcedureName',
  // t('backend-i18n:@totalPrice')
  '@totalPrice',
  // t('backend-i18n:@totalQuantity')
  '@totalQuantity',
  // t('backend-i18n:@totalQuantityUnit')
  '@totalQuantityUnit',
  // t('backend-i18n:@transferDateTime')
  '@transferDateTime',
  // t('backend-i18n:@transferInBedNumber')
  '@transferInBedNumber',
  // t('backend-i18n:@treatmentEndDateTime')
  '@treatmentEndDateTime',
  // t('backend-i18n:@unitPrice')
  '@unitPrice',
  // t('backend-i18n:@wardFeeDiffSelfPay')
  '@wardFeeDiffSelfPay',
  // t('backend-i18n:admissionMethod_CART')
  'admissionMethod_CART',
  // t('backend-i18n:admissionMethod_WALK')
  'admissionMethod_WALK',
  // t('backend-i18n:admissionMethod_WHEELCHAIR')
  'admissionMethod_WHEELCHAIR',
  // t('backend-i18n:batchPermissionFailedReason_ACCOUNT_NOT_ACTIVE')
  'batchPermissionFailedReason_ACCOUNT_NOT_ACTIVE',
  // t('backend-i18n:batchPermissionFailedReason_ACCOUNT_NOT_FOUND')
  'batchPermissionFailedReason_ACCOUNT_NOT_FOUND',
  // t('backend-i18n:batchPermissionFailedReason_ALREADY_ASSIGNED')
  'batchPermissionFailedReason_ALREADY_ASSIGNED',
  // t('backend-i18n:batchPermissionFailedReason_GROUP_NOT_AVAILABLE')
  'batchPermissionFailedReason_GROUP_NOT_AVAILABLE',
  // t('backend-i18n:batchPermissionFailedReason_OTHER')
  'batchPermissionFailedReason_OTHER',
  // t('backend-i18n:batchPermissionFailedReason_PERMIT_NOT_AVAILABLE')
  'batchPermissionFailedReason_PERMIT_NOT_AVAILABLE',
  // t('backend-i18n:bedType_double')
  'bedType_double',
  // t('backend-i18n:bedType_general')
  'bedType_general',
  // t('backend-i18n:bedType_single')
  'bedType_single',
  // t('backend-i18n:bodyPartCode_01')
  'bodyPartCode_01',
  // t('backend-i18n:bodyPartCode_02')
  'bodyPartCode_02',
  // t('backend-i18n:bodyPartCode_03')
  'bodyPartCode_03',
  // t('backend-i18n:bodyPartCode_04')
  'bodyPartCode_04',
  // t('backend-i18n:bodyPartCode_05')
  'bodyPartCode_05',
  // t('backend-i18n:bodyPartCode_06')
  'bodyPartCode_06',
  // t('backend-i18n:bodyPartCode_07')
  'bodyPartCode_07',
  // t('backend-i18n:breastfeedingStatus_breastfeeding')
  'breastfeedingStatus_breastfeeding',
  // t('backend-i18n:breastfeedingStatus_engorged')
  'breastfeedingStatus_engorged',
  // t('backend-i18n:breastfeedingStatus_lactating')
  'breastfeedingStatus_lactating',
  // t('backend-i18n:breastfeedingStatus_weaning')
  'breastfeedingStatus_weaning',
  // t('backend-i18n:cancelled')
  'cancelled',
  // t('backend-i18n:cancerScreening_ineligible')
  'cancerScreening_ineligible',
  // t('backend-i18n:cancerScreening_notScreened')
  'cancerScreening_notScreened',
  // t('backend-i18n:cancerScreening_screened')
  'cancerScreening_screened',
  // t('backend-i18n:codeParameter')
  'codeParameter',
  // t('backend-i18n:completed')
  'completed',
  // t('backend-i18n:country_AD')
  'country_AD',
  // t('backend-i18n:country_AE')
  'country_AE',
  // t('backend-i18n:country_AF')
  'country_AF',
  // t('backend-i18n:country_AG')
  'country_AG',
  // t('backend-i18n:country_AI')
  'country_AI',
  // t('backend-i18n:country_AL')
  'country_AL',
  // t('backend-i18n:country_AM')
  'country_AM',
  // t('backend-i18n:country_AO')
  'country_AO',
  // t('backend-i18n:country_AQ')
  'country_AQ',
  // t('backend-i18n:country_AR')
  'country_AR',
  // t('backend-i18n:country_AS')
  'country_AS',
  // t('backend-i18n:country_AT')
  'country_AT',
  // t('backend-i18n:country_AU')
  'country_AU',
  // t('backend-i18n:country_AW')
  'country_AW',
  // t('backend-i18n:country_AX')
  'country_AX',
  // t('backend-i18n:country_AZ')
  'country_AZ',
  // t('backend-i18n:country_BA')
  'country_BA',
  // t('backend-i18n:country_BB')
  'country_BB',
  // t('backend-i18n:country_BD')
  'country_BD',
  // t('backend-i18n:country_BE')
  'country_BE',
  // t('backend-i18n:country_BF')
  'country_BF',
  // t('backend-i18n:country_BG')
  'country_BG',
  // t('backend-i18n:country_BH')
  'country_BH',
  // t('backend-i18n:country_BI')
  'country_BI',
  // t('backend-i18n:country_BJ')
  'country_BJ',
  // t('backend-i18n:country_BL')
  'country_BL',
  // t('backend-i18n:country_BM')
  'country_BM',
  // t('backend-i18n:country_BN')
  'country_BN',
  // t('backend-i18n:country_BO')
  'country_BO',
  // t('backend-i18n:country_BQ')
  'country_BQ',
  // t('backend-i18n:country_BR')
  'country_BR',
  // t('backend-i18n:country_BS')
  'country_BS',
  // t('backend-i18n:country_BT')
  'country_BT',
  // t('backend-i18n:country_BV')
  'country_BV',
  // t('backend-i18n:country_BW')
  'country_BW',
  // t('backend-i18n:country_BY')
  'country_BY',
  // t('backend-i18n:country_BZ')
  'country_BZ',
  // t('backend-i18n:country_CA')
  'country_CA',
  // t('backend-i18n:country_CC')
  'country_CC',
  // t('backend-i18n:country_CD')
  'country_CD',
  // t('backend-i18n:country_CF')
  'country_CF',
  // t('backend-i18n:country_CG')
  'country_CG',
  // t('backend-i18n:country_CH')
  'country_CH',
  // t('backend-i18n:country_CI')
  'country_CI',
  // t('backend-i18n:country_CK')
  'country_CK',
  // t('backend-i18n:country_CL')
  'country_CL',
  // t('backend-i18n:country_CM')
  'country_CM',
  // t('backend-i18n:country_CN')
  'country_CN',
  // t('backend-i18n:country_CO')
  'country_CO',
  // t('backend-i18n:country_CR')
  'country_CR',
  // t('backend-i18n:country_CU')
  'country_CU',
  // t('backend-i18n:country_CV')
  'country_CV',
  // t('backend-i18n:country_CW')
  'country_CW',
  // t('backend-i18n:country_CX')
  'country_CX',
  // t('backend-i18n:country_CY')
  'country_CY',
  // t('backend-i18n:country_CZ')
  'country_CZ',
  // t('backend-i18n:country_DE')
  'country_DE',
  // t('backend-i18n:country_DJ')
  'country_DJ',
  // t('backend-i18n:country_DK')
  'country_DK',
  // t('backend-i18n:country_DM')
  'country_DM',
  // t('backend-i18n:country_DO')
  'country_DO',
  // t('backend-i18n:country_DZ')
  'country_DZ',
  // t('backend-i18n:country_EC')
  'country_EC',
  // t('backend-i18n:country_EE')
  'country_EE',
  // t('backend-i18n:country_EG')
  'country_EG',
  // t('backend-i18n:country_EH')
  'country_EH',
  // t('backend-i18n:country_ER')
  'country_ER',
  // t('backend-i18n:country_ES')
  'country_ES',
  // t('backend-i18n:country_ET')
  'country_ET',
  // t('backend-i18n:country_FI')
  'country_FI',
  // t('backend-i18n:country_FJ')
  'country_FJ',
  // t('backend-i18n:country_FK')
  'country_FK',
  // t('backend-i18n:country_FM')
  'country_FM',
  // t('backend-i18n:country_FO')
  'country_FO',
  // t('backend-i18n:country_FR')
  'country_FR',
  // t('backend-i18n:country_GA')
  'country_GA',
  // t('backend-i18n:country_GB')
  'country_GB',
  // t('backend-i18n:country_GD')
  'country_GD',
  // t('backend-i18n:country_GE')
  'country_GE',
  // t('backend-i18n:country_GF')
  'country_GF',
  // t('backend-i18n:country_GG')
  'country_GG',
  // t('backend-i18n:country_GH')
  'country_GH',
  // t('backend-i18n:country_GI')
  'country_GI',
  // t('backend-i18n:country_GL')
  'country_GL',
  // t('backend-i18n:country_GM')
  'country_GM',
  // t('backend-i18n:country_GN')
  'country_GN',
  // t('backend-i18n:country_GP')
  'country_GP',
  // t('backend-i18n:country_GQ')
  'country_GQ',
  // t('backend-i18n:country_GR')
  'country_GR',
  // t('backend-i18n:country_GS')
  'country_GS',
  // t('backend-i18n:country_GT')
  'country_GT',
  // t('backend-i18n:country_GU')
  'country_GU',
  // t('backend-i18n:country_GW')
  'country_GW',
  // t('backend-i18n:country_GY')
  'country_GY',
  // t('backend-i18n:country_HK')
  'country_HK',
  // t('backend-i18n:country_HM')
  'country_HM',
  // t('backend-i18n:country_HN')
  'country_HN',
  // t('backend-i18n:country_HR')
  'country_HR',
  // t('backend-i18n:country_HT')
  'country_HT',
  // t('backend-i18n:country_HU')
  'country_HU',
  // t('backend-i18n:country_ID')
  'country_ID',
  // t('backend-i18n:country_IE')
  'country_IE',
  // t('backend-i18n:country_IL')
  'country_IL',
  // t('backend-i18n:country_IM')
  'country_IM',
  // t('backend-i18n:country_IN')
  'country_IN',
  // t('backend-i18n:country_IO')
  'country_IO',
  // t('backend-i18n:country_IQ')
  'country_IQ',
  // t('backend-i18n:country_IR')
  'country_IR',
  // t('backend-i18n:country_IS')
  'country_IS',
  // t('backend-i18n:country_IT')
  'country_IT',
  // t('backend-i18n:country_JE')
  'country_JE',
  // t('backend-i18n:country_JM')
  'country_JM',
  // t('backend-i18n:country_JO')
  'country_JO',
  // t('backend-i18n:country_JP')
  'country_JP',
  // t('backend-i18n:country_KE')
  'country_KE',
  // t('backend-i18n:country_KG')
  'country_KG',
  // t('backend-i18n:country_KH')
  'country_KH',
  // t('backend-i18n:country_KI')
  'country_KI',
  // t('backend-i18n:country_KM')
  'country_KM',
  // t('backend-i18n:country_KN')
  'country_KN',
  // t('backend-i18n:country_KP')
  'country_KP',
  // t('backend-i18n:country_KR')
  'country_KR',
  // t('backend-i18n:country_KW')
  'country_KW',
  // t('backend-i18n:country_KY')
  'country_KY',
  // t('backend-i18n:country_KZ')
  'country_KZ',
  // t('backend-i18n:country_LA')
  'country_LA',
  // t('backend-i18n:country_LB')
  'country_LB',
  // t('backend-i18n:country_LC')
  'country_LC',
  // t('backend-i18n:country_LI')
  'country_LI',
  // t('backend-i18n:country_LK')
  'country_LK',
  // t('backend-i18n:country_LR')
  'country_LR',
  // t('backend-i18n:country_LS')
  'country_LS',
  // t('backend-i18n:country_LT')
  'country_LT',
  // t('backend-i18n:country_LU')
  'country_LU',
  // t('backend-i18n:country_LV')
  'country_LV',
  // t('backend-i18n:country_LY')
  'country_LY',
  // t('backend-i18n:country_MA')
  'country_MA',
  // t('backend-i18n:country_MC')
  'country_MC',
  // t('backend-i18n:country_MD')
  'country_MD',
  // t('backend-i18n:country_ME')
  'country_ME',
  // t('backend-i18n:country_MF')
  'country_MF',
  // t('backend-i18n:country_MG')
  'country_MG',
  // t('backend-i18n:country_MH')
  'country_MH',
  // t('backend-i18n:country_MK')
  'country_MK',
  // t('backend-i18n:country_ML')
  'country_ML',
  // t('backend-i18n:country_MM')
  'country_MM',
  // t('backend-i18n:country_MN')
  'country_MN',
  // t('backend-i18n:country_MO')
  'country_MO',
  // t('backend-i18n:country_MP')
  'country_MP',
  // t('backend-i18n:country_MQ')
  'country_MQ',
  // t('backend-i18n:country_MR')
  'country_MR',
  // t('backend-i18n:country_MS')
  'country_MS',
  // t('backend-i18n:country_MT')
  'country_MT',
  // t('backend-i18n:country_MU')
  'country_MU',
  // t('backend-i18n:country_MV')
  'country_MV',
  // t('backend-i18n:country_MW')
  'country_MW',
  // t('backend-i18n:country_MX')
  'country_MX',
  // t('backend-i18n:country_MY')
  'country_MY',
  // t('backend-i18n:country_MZ')
  'country_MZ',
  // t('backend-i18n:country_NA')
  'country_NA',
  // t('backend-i18n:country_NC')
  'country_NC',
  // t('backend-i18n:country_NE')
  'country_NE',
  // t('backend-i18n:country_NF')
  'country_NF',
  // t('backend-i18n:country_NG')
  'country_NG',
  // t('backend-i18n:country_NI')
  'country_NI',
  // t('backend-i18n:country_NL')
  'country_NL',
  // t('backend-i18n:country_NO')
  'country_NO',
  // t('backend-i18n:country_NP')
  'country_NP',
  // t('backend-i18n:country_NR')
  'country_NR',
  // t('backend-i18n:country_NU')
  'country_NU',
  // t('backend-i18n:country_NZ')
  'country_NZ',
  // t('backend-i18n:country_OM')
  'country_OM',
  // t('backend-i18n:country_PA')
  'country_PA',
  // t('backend-i18n:country_PE')
  'country_PE',
  // t('backend-i18n:country_PF')
  'country_PF',
  // t('backend-i18n:country_PG')
  'country_PG',
  // t('backend-i18n:country_PH')
  'country_PH',
  // t('backend-i18n:country_PK')
  'country_PK',
  // t('backend-i18n:country_PL')
  'country_PL',
  // t('backend-i18n:country_PM')
  'country_PM',
  // t('backend-i18n:country_PN')
  'country_PN',
  // t('backend-i18n:country_PR')
  'country_PR',
  // t('backend-i18n:country_PS')
  'country_PS',
  // t('backend-i18n:country_PT')
  'country_PT',
  // t('backend-i18n:country_PW')
  'country_PW',
  // t('backend-i18n:country_PY')
  'country_PY',
  // t('backend-i18n:country_QA')
  'country_QA',
  // t('backend-i18n:country_RE')
  'country_RE',
  // t('backend-i18n:country_RO')
  'country_RO',
  // t('backend-i18n:country_RS')
  'country_RS',
  // t('backend-i18n:country_RU')
  'country_RU',
  // t('backend-i18n:country_RW')
  'country_RW',
  // t('backend-i18n:country_SA')
  'country_SA',
  // t('backend-i18n:country_SB')
  'country_SB',
  // t('backend-i18n:country_SC')
  'country_SC',
  // t('backend-i18n:country_SD')
  'country_SD',
  // t('backend-i18n:country_SE')
  'country_SE',
  // t('backend-i18n:country_SG')
  'country_SG',
  // t('backend-i18n:country_SH')
  'country_SH',
  // t('backend-i18n:country_SI')
  'country_SI',
  // t('backend-i18n:country_SJ')
  'country_SJ',
  // t('backend-i18n:country_SK')
  'country_SK',
  // t('backend-i18n:country_SL')
  'country_SL',
  // t('backend-i18n:country_SM')
  'country_SM',
  // t('backend-i18n:country_SN')
  'country_SN',
  // t('backend-i18n:country_SO')
  'country_SO',
  // t('backend-i18n:country_SR')
  'country_SR',
  // t('backend-i18n:country_SS')
  'country_SS',
  // t('backend-i18n:country_ST')
  'country_ST',
  // t('backend-i18n:country_SV')
  'country_SV',
  // t('backend-i18n:country_SX')
  'country_SX',
  // t('backend-i18n:country_SY')
  'country_SY',
  // t('backend-i18n:country_SZ')
  'country_SZ',
  // t('backend-i18n:country_TC')
  'country_TC',
  // t('backend-i18n:country_TD')
  'country_TD',
  // t('backend-i18n:country_TF')
  'country_TF',
  // t('backend-i18n:country_TG')
  'country_TG',
  // t('backend-i18n:country_TH')
  'country_TH',
  // t('backend-i18n:country_TJ')
  'country_TJ',
  // t('backend-i18n:country_TK')
  'country_TK',
  // t('backend-i18n:country_TL')
  'country_TL',
  // t('backend-i18n:country_TM')
  'country_TM',
  // t('backend-i18n:country_TN')
  'country_TN',
  // t('backend-i18n:country_TO')
  'country_TO',
  // t('backend-i18n:country_TR')
  'country_TR',
  // t('backend-i18n:country_TT')
  'country_TT',
  // t('backend-i18n:country_TV')
  'country_TV',
  // t('backend-i18n:country_TW')
  'country_TW',
  // t('backend-i18n:country_TZ')
  'country_TZ',
  // t('backend-i18n:country_UA')
  'country_UA',
  // t('backend-i18n:country_UG')
  'country_UG',
  // t('backend-i18n:country_UM')
  'country_UM',
  // t('backend-i18n:country_US')
  'country_US',
  // t('backend-i18n:country_UY')
  'country_UY',
  // t('backend-i18n:country_UZ')
  'country_UZ',
  // t('backend-i18n:country_VA')
  'country_VA',
  // t('backend-i18n:country_VC')
  'country_VC',
  // t('backend-i18n:country_VE')
  'country_VE',
  // t('backend-i18n:country_VG')
  'country_VG',
  // t('backend-i18n:country_VI')
  'country_VI',
  // t('backend-i18n:country_VN')
  'country_VN',
  // t('backend-i18n:country_VU')
  'country_VU',
  // t('backend-i18n:country_WF')
  'country_WF',
  // t('backend-i18n:country_WS')
  'country_WS',
  // t('backend-i18n:country_XK')
  'country_XK',
  // t('backend-i18n:country_YE')
  'country_YE',
  // t('backend-i18n:country_YT')
  'country_YT',
  // t('backend-i18n:country_ZA')
  'country_ZA',
  // t('backend-i18n:country_ZM')
  'country_ZM',
  // t('backend-i18n:country_ZW')
  'country_ZW',
  // t('backend-i18n:divCode_00')
  'divCode_00',
  // t('backend-i18n:divCode_01')
  'divCode_01',
  // t('backend-i18n:divCode_02')
  'divCode_02',
  // t('backend-i18n:divCode_03')
  'divCode_03',
  // t('backend-i18n:divCode_04')
  'divCode_04',
  // t('backend-i18n:divCode_05')
  'divCode_05',
  // t('backend-i18n:divCode_06')
  'divCode_06',
  // t('backend-i18n:divCode_07')
  'divCode_07',
  // t('backend-i18n:divCode_08')
  'divCode_08',
  // t('backend-i18n:divCode_09')
  'divCode_09',
  // t('backend-i18n:divCode_10')
  'divCode_10',
  // t('backend-i18n:divCode_11')
  'divCode_11',
  // t('backend-i18n:divCode_12')
  'divCode_12',
  // t('backend-i18n:divCode_13')
  'divCode_13',
  // t('backend-i18n:divCode_14')
  'divCode_14',
  // t('backend-i18n:divCode_15')
  'divCode_15',
  // t('backend-i18n:divCode_16')
  'divCode_16',
  // t('backend-i18n:divCode_22')
  'divCode_22',
  // t('backend-i18n:divCode_2A')
  'divCode_2A',
  // t('backend-i18n:divCode_2B')
  'divCode_2B',
  // t('backend-i18n:divCode_40')
  'divCode_40',
  // t('backend-i18n:divCode_41')
  'divCode_41',
  // t('backend-i18n:divCode_42')
  'divCode_42',
  // t('backend-i18n:divCode_43')
  'divCode_43',
  // t('backend-i18n:divCode_44')
  'divCode_44',
  // t('backend-i18n:divCode_45')
  'divCode_45',
  // t('backend-i18n:divCode_46')
  'divCode_46',
  // t('backend-i18n:divCode_47')
  'divCode_47',
  // t('backend-i18n:divCode_48')
  'divCode_48',
  // t('backend-i18n:divCode_49')
  'divCode_49',
  // t('backend-i18n:divCode_60')
  'divCode_60',
  // t('backend-i18n:divCode_81')
  'divCode_81',
  // t('backend-i18n:divCode_82')
  'divCode_82',
  // t('backend-i18n:divCode_83')
  'divCode_83',
  // t('backend-i18n:divCode_84')
  'divCode_84',
  // t('backend-i18n:divCode_AA')
  'divCode_AA',
  // t('backend-i18n:divCode_AB')
  'divCode_AB',
  // t('backend-i18n:divCode_AC')
  'divCode_AC',
  // t('backend-i18n:divCode_AD')
  'divCode_AD',
  // t('backend-i18n:divCode_AE')
  'divCode_AE',
  // t('backend-i18n:divCode_AF')
  'divCode_AF',
  // t('backend-i18n:divCode_AG')
  'divCode_AG',
  // t('backend-i18n:divCode_AH')
  'divCode_AH',
  // t('backend-i18n:divCode_AI')
  'divCode_AI',
  // t('backend-i18n:divCode_AJ')
  'divCode_AJ',
  // t('backend-i18n:divCode_BA')
  'divCode_BA',
  // t('backend-i18n:divCode_BB')
  'divCode_BB',
  // t('backend-i18n:divCode_BC')
  'divCode_BC',
  // t('backend-i18n:divCode_BD')
  'divCode_BD',
  // t('backend-i18n:divCode_CA')
  'divCode_CA',
  // t('backend-i18n:divCode_CB')
  'divCode_CB',
  // t('backend-i18n:divCode_DA')
  'divCode_DA',
  // t('backend-i18n:divCode_EA')
  'divCode_EA',
  // t('backend-i18n:divCode_FA')
  'divCode_FA',
  // t('backend-i18n:divCode_FB')
  'divCode_FB',
  // t('backend-i18n:divCode_GA')
  'divCode_GA',
  // t('backend-i18n:divCode_HA')
  'divCode_HA',
  // t('backend-i18n:draft')
  'draft',
  // t('backend-i18n:drainType_DRAIN')
  'drainType_DRAIN',
  // t('backend-i18n:drainType_FOLEY')
  'drainType_FOLEY',
  // t('backend-i18n:drainType_JB_BALL')
  'drainType_JB_BALL',
  // t('backend-i18n:emergencyContact')
  'emergencyContact',
  // t('backend-i18n:encounterParameter')
  'encounterParameter',
  // t('backend-i18n:familyMember_AA')
  'familyMember_AA',
  // t('backend-i18n:familyMember_AUNT')
  'familyMember_AUNT',
  // t('backend-i18n:familyMember_BRO')
  'familyMember_BRO',
  // t('backend-i18n:familyMember_C')
  'familyMember_C',
  // t('backend-i18n:familyMember_CHILD')
  'familyMember_CHILD',
  // t('backend-i18n:familyMember_DAU')
  'familyMember_DAU',
  // t('backend-i18n:familyMember_DOMPART')
  'familyMember_DOMPART',
  // t('backend-i18n:familyMember_FTH')
  'familyMember_FTH',
  // t('backend-i18n:familyMember_GRFTH')
  'familyMember_GRFTH',
  // t('backend-i18n:familyMember_GRMTH')
  'familyMember_GRMTH',
  // t('backend-i18n:familyMember_GRNDCHILD')
  'familyMember_GRNDCHILD',
  // t('backend-i18n:familyMember_GRPRN')
  'familyMember_GRPRN',
  // t('backend-i18n:familyMember_HUSB')
  'familyMember_HUSB',
  // t('backend-i18n:familyMember_INLAW')
  'familyMember_INLAW',
  // t('backend-i18n:familyMember_MTH')
  'familyMember_MTH',
  // t('backend-i18n:familyMember_NIENEPH')
  'familyMember_NIENEPH',
  // t('backend-i18n:familyMember_ONESELF')
  'familyMember_ONESELF',
  // t('backend-i18n:familyMember_PRN')
  'familyMember_PRN',
  // t('backend-i18n:familyMember_PRNINLAW')
  'familyMember_PRNINLAW',
  // t('backend-i18n:familyMember_SIB')
  'familyMember_SIB',
  // t('backend-i18n:familyMember_SIGOTHR')
  'familyMember_SIGOTHR',
  // t('backend-i18n:familyMember_SIS')
  'familyMember_SIS',
  // t('backend-i18n:familyMember_SON')
  'familyMember_SON',
  // t('backend-i18n:familyMember_SPS')
  'familyMember_SPS',
  // t('backend-i18n:familyMember_UNCLE')
  'familyMember_UNCLE',
  // t('backend-i18n:familyMember_WIFE')
  'familyMember_WIFE',
  // t('backend-i18n:firstEmergencyContact')
  'firstEmergencyContact',
  // t('backend-i18n:formCode_category_00')
  'formCode_category_00',
  // t('backend-i18n:formCode_category_A0')
  'formCode_category_A0',
  // t('backend-i18n:formCode_category_A0_01')
  'formCode_category_A0_01',
  // t('backend-i18n:formCode_category_A0_02')
  'formCode_category_A0_02',
  // t('backend-i18n:formCode_category_A0_03')
  'formCode_category_A0_03',
  // t('backend-i18n:formCode_category_A0_04')
  'formCode_category_A0_04',
  // t('backend-i18n:formCode_category_A0_05')
  'formCode_category_A0_05',
  // t('backend-i18n:formCode_category_A0_06')
  'formCode_category_A0_06',
  // t('backend-i18n:formCode_category_A0_07')
  'formCode_category_A0_07',
  // t('backend-i18n:formCode_category_E0')
  'formCode_category_E0',
  // t('backend-i18n:formCode_category_E0_01')
  'formCode_category_E0_01',
  // t('backend-i18n:formCode_category_E0_02')
  'formCode_category_E0_02',
  // t('backend-i18n:formCode_category_E0_03')
  'formCode_category_E0_03',
  // t('backend-i18n:formCode_category_EN')
  'formCode_category_EN',
  // t('backend-i18n:formCode_category_EN_01')
  'formCode_category_EN_01',
  // t('backend-i18n:formCode_category_EN_02')
  'formCode_category_EN_02',
  // t('backend-i18n:formCode_category_EN_03')
  'formCode_category_EN_03',
  // t('backend-i18n:formCode_category_Q0')
  'formCode_category_Q0',
  // t('backend-i18n:formCode_category_Q0_01')
  'formCode_category_Q0_01',
  // t('backend-i18n:formCode_category_Q0_02')
  'formCode_category_Q0_02',
  // t('backend-i18n:formCode_category_Q0_03')
  'formCode_category_Q0_03',
  // t('backend-i18n:formCode_type_01')
  'formCode_type_01',
  // t('backend-i18n:formCode_type_02')
  'formCode_type_02',
  // t('backend-i18n:formCode_type_03')
  'formCode_type_03',
  // t('backend-i18n:fundalHeight_U')
  'fundalHeight_U',
  // t('backend-i18n:fundalHeight_U_MINUS_1')
  'fundalHeight_U_MINUS_1',
  // t('backend-i18n:fundalHeight_U_MINUS_2')
  'fundalHeight_U_MINUS_2',
  // t('backend-i18n:fundalHeight_U_PLUS_1')
  'fundalHeight_U_PLUS_1',
  // t('backend-i18n:fundalHeight_U_PLUS_2')
  'fundalHeight_U_PLUS_2',
  // t('backend-i18n:gender_female')
  'gender_female',
  // t('backend-i18n:gender_male')
  'gender_male',
  // t('backend-i18n:gender_other')
  'gender_other',
  // t('backend-i18n:gender_unknown')
  'gender_unknown',
  // t('backend-i18n:hospitalBasicInfo')
  'hospitalBasicInfo',
  // t('backend-i18n:language_ar')
  'language_ar',
  // t('backend-i18n:language_bn')
  'language_bn',
  // t('backend-i18n:language_cs')
  'language_cs',
  // t('backend-i18n:language_da')
  'language_da',
  // t('backend-i18n:language_de')
  'language_de',
  // t('backend-i18n:language_de-AT')
  'language_de-AT',
  // t('backend-i18n:language_de-CH')
  'language_de-CH',
  // t('backend-i18n:language_de-DE')
  'language_de-DE',
  // t('backend-i18n:language_el')
  'language_el',
  // t('backend-i18n:language_en')
  'language_en',
  // t('backend-i18n:language_en-AU')
  'language_en-AU',
  // t('backend-i18n:language_en-CA')
  'language_en-CA',
  // t('backend-i18n:language_en-GB')
  'language_en-GB',
  // t('backend-i18n:language_en-IN')
  'language_en-IN',
  // t('backend-i18n:language_en-NZ')
  'language_en-NZ',
  // t('backend-i18n:language_en-SG')
  'language_en-SG',
  // t('backend-i18n:language_en-US')
  'language_en-US',
  // t('backend-i18n:language_es')
  'language_es',
  // t('backend-i18n:language_es-AR')
  'language_es-AR',
  // t('backend-i18n:language_es-ES')
  'language_es-ES',
  // t('backend-i18n:language_es-UY')
  'language_es-UY',
  // t('backend-i18n:language_fi')
  'language_fi',
  // t('backend-i18n:language_fr')
  'language_fr',
  // t('backend-i18n:language_fr-BE')
  'language_fr-BE',
  // t('backend-i18n:language_fr-CH')
  'language_fr-CH',
  // t('backend-i18n:language_fr-FR')
  'language_fr-FR',
  // t('backend-i18n:language_fy')
  'language_fy',
  // t('backend-i18n:language_fy-NL')
  'language_fy-NL',
  // t('backend-i18n:language_hi')
  'language_hi',
  // t('backend-i18n:language_hr')
  'language_hr',
  // t('backend-i18n:language_it')
  'language_it',
  // t('backend-i18n:language_it-CH')
  'language_it-CH',
  // t('backend-i18n:language_it-IT')
  'language_it-IT',
  // t('backend-i18n:language_ja')
  'language_ja',
  // t('backend-i18n:language_ko')
  'language_ko',
  // t('backend-i18n:language_nl')
  'language_nl',
  // t('backend-i18n:language_nl-BE')
  'language_nl-BE',
  // t('backend-i18n:language_nl-NL')
  'language_nl-NL',
  // t('backend-i18n:language_no')
  'language_no',
  // t('backend-i18n:language_no-NO')
  'language_no-NO',
  // t('backend-i18n:language_pa')
  'language_pa',
  // t('backend-i18n:language_pl')
  'language_pl',
  // t('backend-i18n:language_pt')
  'language_pt',
  // t('backend-i18n:language_pt-BR')
  'language_pt-BR',
  // t('backend-i18n:language_ru')
  'language_ru',
  // t('backend-i18n:language_ru-RU')
  'language_ru-RU',
  // t('backend-i18n:language_sr')
  'language_sr',
  // t('backend-i18n:language_sr-RS')
  'language_sr-RS',
  // t('backend-i18n:language_sv')
  'language_sv',
  // t('backend-i18n:language_sv-SE')
  'language_sv-SE',
  // t('backend-i18n:language_te')
  'language_te',
  // t('backend-i18n:language_zh')
  'language_zh',
  // t('backend-i18n:language_zh-CN')
  'language_zh-CN',
  // t('backend-i18n:language_zh-HK')
  'language_zh-HK',
  // t('backend-i18n:language_zh-SG')
  'language_zh-SG',
  // t('backend-i18n:language_zh-TW')
  'language_zh-TW',
  // t('backend-i18n:lochiaAmount_HEAVY')
  'lochiaAmount_HEAVY',
  // t('backend-i18n:lochiaAmount_LIGHT')
  'lochiaAmount_LIGHT',
  // t('backend-i18n:lochiaAmount_MODERATE')
  'lochiaAmount_MODERATE',
  // t('backend-i18n:lochiaAmount_SCANTY')
  'lochiaAmount_SCANTY',
  // t('backend-i18n:lochiaColor_ALBA')
  'lochiaColor_ALBA',
  // t('backend-i18n:lochiaColor_RUBRA')
  'lochiaColor_RUBRA',
  // t('backend-i18n:lochiaColor_SEROSA')
  'lochiaColor_SEROSA',
  // t('backend-i18n:lochiaOdor_FOUL')
  'lochiaOdor_FOUL',
  // t('backend-i18n:lochiaOdor_NORMAL')
  'lochiaOdor_NORMAL',
  // t('backend-i18n:marital_A')
  'marital_A',
  // t('backend-i18n:marital_D')
  'marital_D',
  // t('backend-i18n:marital_I')
  'marital_I',
  // t('backend-i18n:marital_L')
  'marital_L',
  // t('backend-i18n:marital_M')
  'marital_M',
  // t('backend-i18n:marital_P')
  'marital_P',
  // t('backend-i18n:marital_S')
  'marital_S',
  // t('backend-i18n:marital_T')
  'marital_T',
  // t('backend-i18n:marital_U')
  'marital_U',
  // t('backend-i18n:marital_UNK')
  'marital_UNK',
  // t('backend-i18n:marital_W')
  'marital_W',
  // t('backend-i18n:nippleAppearance_brokenSkin')
  'nippleAppearance_brokenSkin',
  // t('backend-i18n:nippleAppearance_flat')
  'nippleAppearance_flat',
  // t('backend-i18n:nippleAppearance_inverted')
  'nippleAppearance_inverted',
  // t('backend-i18n:nippleAppearance_normal')
  'nippleAppearance_normal',
  // t('backend-i18n:observationInterpretation_<')
  'observationInterpretation_<',
  // t('backend-i18n:observationInterpretation_>')
  'observationInterpretation_>',
  // t('backend-i18n:observationInterpretation_A')
  'observationInterpretation_A',
  // t('backend-i18n:observationInterpretation_AA')
  'observationInterpretation_AA',
  // t('backend-i18n:observationInterpretation_B')
  'observationInterpretation_B',
  // t('backend-i18n:observationInterpretation_CAR')
  'observationInterpretation_CAR',
  // t('backend-i18n:observationInterpretation_D')
  'observationInterpretation_D',
  // t('backend-i18n:observationInterpretation_DET')
  'observationInterpretation_DET',
  // t('backend-i18n:observationInterpretation_E')
  'observationInterpretation_E',
  // t('backend-i18n:observationInterpretation_EX')
  'observationInterpretation_EX',
  // t('backend-i18n:observationInterpretation_EXP')
  'observationInterpretation_EXP',
  // t('backend-i18n:observationInterpretation_H')
  'observationInterpretation_H',
  // t('backend-i18n:observationInterpretation_HH')
  'observationInterpretation_HH',
  // t('backend-i18n:observationInterpretation_HU')
  'observationInterpretation_HU',
  // t('backend-i18n:observationInterpretation_HX')
  'observationInterpretation_HX',
  // t('backend-i18n:observationInterpretation_I')
  'observationInterpretation_I',
  // t('backend-i18n:observationInterpretation_IE')
  'observationInterpretation_IE',
  // t('backend-i18n:observationInterpretation_IND')
  'observationInterpretation_IND',
  // t('backend-i18n:observationInterpretation_L')
  'observationInterpretation_L',
  // t('backend-i18n:observationInterpretation_LL')
  'observationInterpretation_LL',
  // t('backend-i18n:observationInterpretation_LU')
  'observationInterpretation_LU',
  // t('backend-i18n:observationInterpretation_LX')
  'observationInterpretation_LX',
  // t('backend-i18n:observationInterpretation_N')
  'observationInterpretation_N',
  // t('backend-i18n:observationInterpretation_NCL')
  'observationInterpretation_NCL',
  // t('backend-i18n:observationInterpretation_ND')
  'observationInterpretation_ND',
  // t('backend-i18n:observationInterpretation_NEG')
  'observationInterpretation_NEG',
  // t('backend-i18n:observationInterpretation_NR')
  'observationInterpretation_NR',
  // t('backend-i18n:observationInterpretation_NS')
  'observationInterpretation_NS',
  // t('backend-i18n:observationInterpretation_POS')
  'observationInterpretation_POS',
  // t('backend-i18n:observationInterpretation_R')
  'observationInterpretation_R',
  // t('backend-i18n:observationInterpretation_RR')
  'observationInterpretation_RR',
  // t('backend-i18n:observationInterpretation_S')
  'observationInterpretation_S',
  // t('backend-i18n:observationInterpretation_SDD')
  'observationInterpretation_SDD',
  // t('backend-i18n:observationInterpretation_SYN-R')
  'observationInterpretation_SYN-R',
  // t('backend-i18n:observationInterpretation_SYN-S')
  'observationInterpretation_SYN-S',
  // t('backend-i18n:observationInterpretation_U')
  'observationInterpretation_U',
  // t('backend-i18n:observationInterpretation_UNE')
  'observationInterpretation_UNE',
  // t('backend-i18n:observationInterpretation_W')
  'observationInterpretation_W',
  // t('backend-i18n:observationInterpretation_WR')
  'observationInterpretation_WR',
  // t('backend-i18n:occupation_0')
  'occupation_0',
  // t('backend-i18n:occupation_01')
  'occupation_01',
  // t('backend-i18n:occupation_011')
  'occupation_011',
  // t('backend-i18n:occupation_0110')
  'occupation_0110',
  // t('backend-i18n:occupation_012')
  'occupation_012',
  // t('backend-i18n:occupation_0120')
  'occupation_0120',
  // t('backend-i18n:occupation_1')
  'occupation_1',
  // t('backend-i18n:occupation_11')
  'occupation_11',
  // t('backend-i18n:occupation_111')
  'occupation_111',
  // t('backend-i18n:occupation_1111')
  'occupation_1111',
  // t('backend-i18n:occupation_1112')
  'occupation_1112',
  // t('backend-i18n:occupation_1113')
  'occupation_1113',
  // t('backend-i18n:occupation_112')
  'occupation_112',
  // t('backend-i18n:occupation_1120')
  'occupation_1120',
  // t('backend-i18n:occupation_12')
  'occupation_12',
  // t('backend-i18n:occupation_121')
  'occupation_121',
  // t('backend-i18n:occupation_1211')
  'occupation_1211',
  // t('backend-i18n:occupation_1212')
  'occupation_1212',
  // t('backend-i18n:occupation_1219')
  'occupation_1219',
  // t('backend-i18n:occupation_122')
  'occupation_122',
  // t('backend-i18n:occupation_1221')
  'occupation_1221',
  // t('backend-i18n:occupation_1222')
  'occupation_1222',
  // t('backend-i18n:occupation_1223')
  'occupation_1223',
  // t('backend-i18n:occupation_13')
  'occupation_13',
  // t('backend-i18n:occupation_131')
  'occupation_131',
  // t('backend-i18n:occupation_1310')
  'occupation_1310',
  // t('backend-i18n:occupation_132')
  'occupation_132',
  // t('backend-i18n:occupation_1321')
  'occupation_1321',
  // t('backend-i18n:occupation_1322')
  'occupation_1322',
  // t('backend-i18n:occupation_1323')
  'occupation_1323',
  // t('backend-i18n:occupation_1324')
  'occupation_1324',
  // t('backend-i18n:occupation_133')
  'occupation_133',
  // t('backend-i18n:occupation_1330')
  'occupation_1330',
  // t('backend-i18n:occupation_134')
  'occupation_134',
  // t('backend-i18n:occupation_1341')
  'occupation_1341',
  // t('backend-i18n:occupation_1342')
  'occupation_1342',
  // t('backend-i18n:occupation_1343')
  'occupation_1343',
  // t('backend-i18n:occupation_1344')
  'occupation_1344',
  // t('backend-i18n:occupation_1345')
  'occupation_1345',
  // t('backend-i18n:occupation_1349')
  'occupation_1349',
  // t('backend-i18n:occupation_14')
  'occupation_14',
  // t('backend-i18n:occupation_141')
  'occupation_141',
  // t('backend-i18n:occupation_1411')
  'occupation_1411',
  // t('backend-i18n:occupation_1412')
  'occupation_1412',
  // t('backend-i18n:occupation_142')
  'occupation_142',
  // t('backend-i18n:occupation_1420')
  'occupation_1420',
  // t('backend-i18n:occupation_149')
  'occupation_149',
  // t('backend-i18n:occupation_1491')
  'occupation_1491',
  // t('backend-i18n:occupation_1499')
  'occupation_1499',
  // t('backend-i18n:occupation_2')
  'occupation_2',
  // t('backend-i18n:occupation_21')
  'occupation_21',
  // t('backend-i18n:occupation_211')
  'occupation_211',
  // t('backend-i18n:occupation_2111')
  'occupation_2111',
  // t('backend-i18n:occupation_2112')
  'occupation_2112',
  // t('backend-i18n:occupation_2113')
  'occupation_2113',
  // t('backend-i18n:occupation_2114')
  'occupation_2114',
  // t('backend-i18n:occupation_212')
  'occupation_212',
  // t('backend-i18n:occupation_2120')
  'occupation_2120',
  // t('backend-i18n:occupation_213')
  'occupation_213',
  // t('backend-i18n:occupation_2131')
  'occupation_2131',
  // t('backend-i18n:occupation_2132')
  'occupation_2132',
  // t('backend-i18n:occupation_2133')
  'occupation_2133',
  // t('backend-i18n:occupation_214')
  'occupation_214',
  // t('backend-i18n:occupation_2141')
  'occupation_2141',
  // t('backend-i18n:occupation_2142')
  'occupation_2142',
  // t('backend-i18n:occupation_2143')
  'occupation_2143',
  // t('backend-i18n:occupation_2144')
  'occupation_2144',
  // t('backend-i18n:occupation_2145')
  'occupation_2145',
  // t('backend-i18n:occupation_2146')
  'occupation_2146',
  // t('backend-i18n:occupation_2149')
  'occupation_2149',
  // t('backend-i18n:occupation_215')
  'occupation_215',
  // t('backend-i18n:occupation_2151')
  'occupation_2151',
  // t('backend-i18n:occupation_2152')
  'occupation_2152',
  // t('backend-i18n:occupation_2153')
  'occupation_2153',
  // t('backend-i18n:occupation_216')
  'occupation_216',
  // t('backend-i18n:occupation_2161')
  'occupation_2161',
  // t('backend-i18n:occupation_2162')
  'occupation_2162',
  // t('backend-i18n:occupation_2163')
  'occupation_2163',
  // t('backend-i18n:occupation_217')
  'occupation_217',
  // t('backend-i18n:occupation_2171')
  'occupation_2171',
  // t('backend-i18n:occupation_2172')
  'occupation_2172',
  // t('backend-i18n:occupation_2173')
  'occupation_2173',
  // t('backend-i18n:occupation_22')
  'occupation_22',
  // t('backend-i18n:occupation_221')
  'occupation_221',
  // t('backend-i18n:occupation_2210')
  'occupation_2210',
  // t('backend-i18n:occupation_222')
  'occupation_222',
  // t('backend-i18n:occupation_2220')
  'occupation_2220',
  // t('backend-i18n:occupation_223')
  'occupation_223',
  // t('backend-i18n:occupation_2230')
  'occupation_2230',
  // t('backend-i18n:occupation_224')
  'occupation_224',
  // t('backend-i18n:occupation_2240')
  'occupation_2240',
  // t('backend-i18n:occupation_225')
  'occupation_225',
  // t('backend-i18n:occupation_2250')
  'occupation_2250',
  // t('backend-i18n:occupation_226')
  'occupation_226',
  // t('backend-i18n:occupation_2260')
  'occupation_2260',
  // t('backend-i18n:occupation_229')
  'occupation_229',
  // t('backend-i18n:occupation_2291')
  'occupation_2291',
  // t('backend-i18n:occupation_2292')
  'occupation_2292',
  // t('backend-i18n:occupation_2293')
  'occupation_2293',
  // t('backend-i18n:occupation_2294')
  'occupation_2294',
  // t('backend-i18n:occupation_2295')
  'occupation_2295',
  // t('backend-i18n:occupation_2299')
  'occupation_2299',
  // t('backend-i18n:occupation_23')
  'occupation_23',
  // t('backend-i18n:occupation_231')
  'occupation_231',
  // t('backend-i18n:occupation_2310')
  'occupation_2310',
  // t('backend-i18n:occupation_232')
  'occupation_232',
  // t('backend-i18n:occupation_2320')
  'occupation_2320',
  // t('backend-i18n:occupation_233')
  'occupation_233',
  // t('backend-i18n:occupation_2331')
  'occupation_2331',
  // t('backend-i18n:occupation_2332')
  'occupation_2332',
  // t('backend-i18n:occupation_234')
  'occupation_234',
  // t('backend-i18n:occupation_2340')
  'occupation_2340',
  // t('backend-i18n:occupation_239')
  'occupation_239',
  // t('backend-i18n:occupation_2391')
  'occupation_2391',
  // t('backend-i18n:occupation_2392')
  'occupation_2392',
  // t('backend-i18n:occupation_2393')
  'occupation_2393',
  // t('backend-i18n:occupation_2394')
  'occupation_2394',
  // t('backend-i18n:occupation_2395')
  'occupation_2395',
  // t('backend-i18n:occupation_2399')
  'occupation_2399',
  // t('backend-i18n:occupation_24')
  'occupation_24',
  // t('backend-i18n:occupation_241')
  'occupation_241',
  // t('backend-i18n:occupation_2411')
  'occupation_2411',
  // t('backend-i18n:occupation_2412')
  'occupation_2412',
  // t('backend-i18n:occupation_242')
  'occupation_242',
  // t('backend-i18n:occupation_2421')
  'occupation_2421',
  // t('backend-i18n:occupation_2422')
  'occupation_2422',
  // t('backend-i18n:occupation_243')
  'occupation_243',
  // t('backend-i18n:occupation_2431')
  'occupation_2431',
  // t('backend-i18n:occupation_2432')
  'occupation_2432',
  // t('backend-i18n:occupation_2433')
  'occupation_2433',
  // t('backend-i18n:occupation_2434')
  'occupation_2434',
  // t('backend-i18n:occupation_25')
  'occupation_25',
  // t('backend-i18n:occupation_251')
  'occupation_251',
  // t('backend-i18n:occupation_2511')
  'occupation_2511',
  // t('backend-i18n:occupation_2512')
  'occupation_2512',
  // t('backend-i18n:occupation_2513')
  'occupation_2513',
  // t('backend-i18n:occupation_2519')
  'occupation_2519',
  // t('backend-i18n:occupation_252')
  'occupation_252',
  // t('backend-i18n:occupation_2521')
  'occupation_2521',
  // t('backend-i18n:occupation_2522')
  'occupation_2522',
  // t('backend-i18n:occupation_2523')
  'occupation_2523',
  // t('backend-i18n:occupation_2529')
  'occupation_2529',
  // t('backend-i18n:occupation_26')
  'occupation_26',
  // t('backend-i18n:occupation_261')
  'occupation_261',
  // t('backend-i18n:occupation_2611')
  'occupation_2611',
  // t('backend-i18n:occupation_2612')
  'occupation_2612',
  // t('backend-i18n:occupation_2613')
  'occupation_2613',
  // t('backend-i18n:occupation_2619')
  'occupation_2619',
  // t('backend-i18n:occupation_262')
  'occupation_262',
  // t('backend-i18n:occupation_2621')
  'occupation_2621',
  // t('backend-i18n:occupation_2622')
  'occupation_2622',
  // t('backend-i18n:occupation_263')
  'occupation_263',
  // t('backend-i18n:occupation_2631')
  'occupation_2631',
  // t('backend-i18n:occupation_2632')
  'occupation_2632',
  // t('backend-i18n:occupation_2633')
  'occupation_2633',
  // t('backend-i18n:occupation_2634')
  'occupation_2634',
  // t('backend-i18n:occupation_2635')
  'occupation_2635',
  // t('backend-i18n:occupation_2636')
  'occupation_2636',
  // t('backend-i18n:occupation_264')
  'occupation_264',
  // t('backend-i18n:occupation_2641')
  'occupation_2641',
  // t('backend-i18n:occupation_2642')
  'occupation_2642',
  // t('backend-i18n:occupation_2643')
  'occupation_2643',
  // t('backend-i18n:occupation_265')
  'occupation_265',
  // t('backend-i18n:occupation_2651')
  'occupation_2651',
  // t('backend-i18n:occupation_2652')
  'occupation_2652',
  // t('backend-i18n:occupation_2653')
  'occupation_2653',
  // t('backend-i18n:occupation_2654')
  'occupation_2654',
  // t('backend-i18n:occupation_2655')
  'occupation_2655',
  // t('backend-i18n:occupation_2656')
  'occupation_2656',
  // t('backend-i18n:occupation_2659')
  'occupation_2659',
  // t('backend-i18n:occupation_3')
  'occupation_3',
  // t('backend-i18n:occupation_31')
  'occupation_31',
  // t('backend-i18n:occupation_311')
  'occupation_311',
  // t('backend-i18n:occupation_3111')
  'occupation_3111',
  // t('backend-i18n:occupation_3112')
  'occupation_3112',
  // t('backend-i18n:occupation_3113')
  'occupation_3113',
  // t('backend-i18n:occupation_3114')
  'occupation_3114',
  // t('backend-i18n:occupation_3115')
  'occupation_3115',
  // t('backend-i18n:occupation_3116')
  'occupation_3116',
  // t('backend-i18n:occupation_3117')
  'occupation_3117',
  // t('backend-i18n:occupation_3118')
  'occupation_3118',
  // t('backend-i18n:occupation_3119')
  'occupation_3119',
  // t('backend-i18n:occupation_312')
  'occupation_312',
  // t('backend-i18n:occupation_3121')
  'occupation_3121',
  // t('backend-i18n:occupation_3122')
  'occupation_3122',
  // t('backend-i18n:occupation_3123')
  'occupation_3123',
  // t('backend-i18n:occupation_313')
  'occupation_313',
  // t('backend-i18n:occupation_3131')
  'occupation_3131',
  // t('backend-i18n:occupation_3132')
  'occupation_3132',
  // t('backend-i18n:occupation_3133')
  'occupation_3133',
  // t('backend-i18n:occupation_3134')
  'occupation_3134',
  // t('backend-i18n:occupation_3135')
  'occupation_3135',
  // t('backend-i18n:occupation_3139')
  'occupation_3139',
  // t('backend-i18n:occupation_314')
  'occupation_314',
  // t('backend-i18n:occupation_3141')
  'occupation_3141',
  // t('backend-i18n:occupation_3142')
  'occupation_3142',
  // t('backend-i18n:occupation_315')
  'occupation_315',
  // t('backend-i18n:occupation_3151')
  'occupation_3151',
  // t('backend-i18n:occupation_3152')
  'occupation_3152',
  // t('backend-i18n:occupation_3153')
  'occupation_3153',
  // t('backend-i18n:occupation_3154')
  'occupation_3154',
  // t('backend-i18n:occupation_3155')
  'occupation_3155',
  // t('backend-i18n:occupation_32')
  'occupation_32',
  // t('backend-i18n:occupation_321')
  'occupation_321',
  // t('backend-i18n:occupation_3211')
  'occupation_3211',
  // t('backend-i18n:occupation_3212')
  'occupation_3212',
  // t('backend-i18n:occupation_3213')
  'occupation_3213',
  // t('backend-i18n:occupation_3214')
  'occupation_3214',
  // t('backend-i18n:occupation_322')
  'occupation_322',
  // t('backend-i18n:occupation_3220')
  'occupation_3220',
  // t('backend-i18n:occupation_323')
  'occupation_323',
  // t('backend-i18n:occupation_3230')
  'occupation_3230',
  // t('backend-i18n:occupation_324')
  'occupation_324',
  // t('backend-i18n:occupation_3240')
  'occupation_3240',
  // t('backend-i18n:occupation_329')
  'occupation_329',
  // t('backend-i18n:occupation_3291')
  'occupation_3291',
  // t('backend-i18n:occupation_3292')
  'occupation_3292',
  // t('backend-i18n:occupation_3293')
  'occupation_3293',
  // t('backend-i18n:occupation_3294')
  'occupation_3294',
  // t('backend-i18n:occupation_3295')
  'occupation_3295',
  // t('backend-i18n:occupation_3296')
  'occupation_3296',
  // t('backend-i18n:occupation_3299')
  'occupation_3299',
  // t('backend-i18n:occupation_33')
  'occupation_33',
  // t('backend-i18n:occupation_331')
  'occupation_331',
  // t('backend-i18n:occupation_3311')
  'occupation_3311',
  // t('backend-i18n:occupation_3312')
  'occupation_3312',
  // t('backend-i18n:occupation_3313')
  'occupation_3313',
  // t('backend-i18n:occupation_3314')
  'occupation_3314',
  // t('backend-i18n:occupation_3315')
  'occupation_3315',
  // t('backend-i18n:occupation_332')
  'occupation_332',
  // t('backend-i18n:occupation_3321')
  'occupation_3321',
  // t('backend-i18n:occupation_3322')
  'occupation_3322',
  // t('backend-i18n:occupation_3323')
  'occupation_3323',
  // t('backend-i18n:occupation_3324')
  'occupation_3324',
  // t('backend-i18n:occupation_333')
  'occupation_333',
  // t('backend-i18n:occupation_3331')
  'occupation_3331',
  // t('backend-i18n:occupation_3332')
  'occupation_3332',
  // t('backend-i18n:occupation_3333')
  'occupation_3333',
  // t('backend-i18n:occupation_3334')
  'occupation_3334',
  // t('backend-i18n:occupation_3339')
  'occupation_3339',
  // t('backend-i18n:occupation_334')
  'occupation_334',
  // t('backend-i18n:occupation_3341')
  'occupation_3341',
  // t('backend-i18n:occupation_3342')
  'occupation_3342',
  // t('backend-i18n:occupation_335')
  'occupation_335',
  // t('backend-i18n:occupation_3351')
  'occupation_3351',
  // t('backend-i18n:occupation_3352')
  'occupation_3352',
  // t('backend-i18n:occupation_3353')
  'occupation_3353',
  // t('backend-i18n:occupation_3354')
  'occupation_3354',
  // t('backend-i18n:occupation_3355')
  'occupation_3355',
  // t('backend-i18n:occupation_3359')
  'occupation_3359',
  // t('backend-i18n:occupation_34')
  'occupation_34',
  // t('backend-i18n:occupation_341')
  'occupation_341',
  // t('backend-i18n:occupation_3411')
  'occupation_3411',
  // t('backend-i18n:occupation_3412')
  'occupation_3412',
  // t('backend-i18n:occupation_3413')
  'occupation_3413',
  // t('backend-i18n:occupation_342')
  'occupation_342',
  // t('backend-i18n:occupation_3421')
  'occupation_3421',
  // t('backend-i18n:occupation_3422')
  'occupation_3422',
  // t('backend-i18n:occupation_343')
  'occupation_343',
  // t('backend-i18n:occupation_3431')
  'occupation_3431',
  // t('backend-i18n:occupation_3432')
  'occupation_3432',
  // t('backend-i18n:occupation_3433')
  'occupation_3433',
  // t('backend-i18n:occupation_3439')
  'occupation_3439',
  // t('backend-i18n:occupation_35')
  'occupation_35',
  // t('backend-i18n:occupation_351')
  'occupation_351',
  // t('backend-i18n:occupation_3511')
  'occupation_3511',
  // t('backend-i18n:occupation_3512')
  'occupation_3512',
  // t('backend-i18n:occupation_3513')
  'occupation_3513',
  // t('backend-i18n:occupation_3514')
  'occupation_3514',
  // t('backend-i18n:occupation_352')
  'occupation_352',
  // t('backend-i18n:occupation_3521')
  'occupation_3521',
  // t('backend-i18n:occupation_3522')
  'occupation_3522',
  // t('backend-i18n:occupation_4')
  'occupation_4',
  // t('backend-i18n:occupation_41')
  'occupation_41',
  // t('backend-i18n:occupation_411')
  'occupation_411',
  // t('backend-i18n:occupation_4110')
  'occupation_4110',
  // t('backend-i18n:occupation_412')
  'occupation_412',
  // t('backend-i18n:occupation_4120')
  'occupation_4120',
  // t('backend-i18n:occupation_413')
  'occupation_413',
  // t('backend-i18n:occupation_4130')
  'occupation_4130',
  // t('backend-i18n:occupation_42')
  'occupation_42',
  // t('backend-i18n:occupation_421')
  'occupation_421',
  // t('backend-i18n:occupation_4211')
  'occupation_4211',
  // t('backend-i18n:occupation_4212')
  'occupation_4212',
  // t('backend-i18n:occupation_4213')
  'occupation_4213',
  // t('backend-i18n:occupation_4214')
  'occupation_4214',
  // t('backend-i18n:occupation_422')
  'occupation_422',
  // t('backend-i18n:occupation_4221')
  'occupation_4221',
  // t('backend-i18n:occupation_4222')
  'occupation_4222',
  // t('backend-i18n:occupation_4223')
  'occupation_4223',
  // t('backend-i18n:occupation_4224')
  'occupation_4224',
  // t('backend-i18n:occupation_4225')
  'occupation_4225',
  // t('backend-i18n:occupation_4229')
  'occupation_4229',
  // t('backend-i18n:occupation_43')
  'occupation_43',
  // t('backend-i18n:occupation_431')
  'occupation_431',
  // t('backend-i18n:occupation_4311')
  'occupation_4311',
  // t('backend-i18n:occupation_4312')
  'occupation_4312',
  // t('backend-i18n:occupation_432')
  'occupation_432',
  // t('backend-i18n:occupation_4321')
  'occupation_4321',
  // t('backend-i18n:occupation_4322')
  'occupation_4322',
  // t('backend-i18n:occupation_4323')
  'occupation_4323',
  // t('backend-i18n:occupation_49')
  'occupation_49',
  // t('backend-i18n:occupation_491')
  'occupation_491',
  // t('backend-i18n:occupation_4910')
  'occupation_4910',
  // t('backend-i18n:occupation_499')
  'occupation_499',
  // t('backend-i18n:occupation_4991')
  'occupation_4991',
  // t('backend-i18n:occupation_4992')
  'occupation_4992',
  // t('backend-i18n:occupation_4993')
  'occupation_4993',
  // t('backend-i18n:occupation_4994')
  'occupation_4994',
  // t('backend-i18n:occupation_4995')
  'occupation_4995',
  // t('backend-i18n:occupation_4999')
  'occupation_4999',
  // t('backend-i18n:occupation_5')
  'occupation_5',
  // t('backend-i18n:occupation_51')
  'occupation_51',
  // t('backend-i18n:occupation_511')
  'occupation_511',
  // t('backend-i18n:occupation_5111')
  'occupation_5111',
  // t('backend-i18n:occupation_5112')
  'occupation_5112',
  // t('backend-i18n:occupation_5113')
  'occupation_5113',
  // t('backend-i18n:occupation_512')
  'occupation_512',
  // t('backend-i18n:occupation_5120')
  'occupation_5120',
  // t('backend-i18n:occupation_513')
  'occupation_513',
  // t('backend-i18n:occupation_5131')
  'occupation_5131',
  // t('backend-i18n:occupation_5139')
  'occupation_5139',
  // t('backend-i18n:occupation_514')
  'occupation_514',
  // t('backend-i18n:occupation_5140')
  'occupation_5140',
  // t('backend-i18n:occupation_515')
  'occupation_515',
  // t('backend-i18n:occupation_5151')
  'occupation_5151',
  // t('backend-i18n:occupation_5152')
  'occupation_5152',
  // t('backend-i18n:occupation_5159')
  'occupation_5159',
  // t('backend-i18n:occupation_519')
  'occupation_519',
  // t('backend-i18n:occupation_5191')
  'occupation_5191',
  // t('backend-i18n:occupation_5192')
  'occupation_5192',
  // t('backend-i18n:occupation_5193')
  'occupation_5193',
  // t('backend-i18n:occupation_5194')
  'occupation_5194',
  // t('backend-i18n:occupation_5199')
  'occupation_5199',
  // t('backend-i18n:occupation_52')
  'occupation_52',
  // t('backend-i18n:occupation_521')
  'occupation_521',
  // t('backend-i18n:occupation_5211')
  'occupation_5211',
  // t('backend-i18n:occupation_5212')
  'occupation_5212',
  // t('backend-i18n:occupation_522')
  'occupation_522',
  // t('backend-i18n:occupation_5220')
  'occupation_5220',
  // t('backend-i18n:occupation_523')
  'occupation_523',
  // t('backend-i18n:occupation_5230')
  'occupation_5230',
  // t('backend-i18n:occupation_524')
  'occupation_524',
  // t('backend-i18n:occupation_5241')
  'occupation_5241',
  // t('backend-i18n:occupation_5242')
  'occupation_5242',
  // t('backend-i18n:occupation_5249')
  'occupation_5249',
  // t('backend-i18n:occupation_53')
  'occupation_53',
  // t('backend-i18n:occupation_531')
  'occupation_531',
  // t('backend-i18n:occupation_5311')
  'occupation_5311',
  // t('backend-i18n:occupation_5312')
  'occupation_5312',
  // t('backend-i18n:occupation_532')
  'occupation_532',
  // t('backend-i18n:occupation_5321')
  'occupation_5321',
  // t('backend-i18n:occupation_5322')
  'occupation_5322',
  // t('backend-i18n:occupation_5329')
  'occupation_5329',
  // t('backend-i18n:occupation_54')
  'occupation_54',
  // t('backend-i18n:occupation_541')
  'occupation_541',
  // t('backend-i18n:occupation_5411')
  'occupation_5411',
  // t('backend-i18n:occupation_5412')
  'occupation_5412',
  // t('backend-i18n:occupation_5413')
  'occupation_5413',
  // t('backend-i18n:occupation_5414')
  'occupation_5414',
  // t('backend-i18n:occupation_5419')
  'occupation_5419',
  // t('backend-i18n:occupation_6')
  'occupation_6',
  // t('backend-i18n:occupation_61')
  'occupation_61',
  // t('backend-i18n:occupation_611')
  'occupation_611',
  // t('backend-i18n:occupation_6111')
  'occupation_6111',
  // t('backend-i18n:occupation_6112')
  'occupation_6112',
  // t('backend-i18n:occupation_6113')
  'occupation_6113',
  // t('backend-i18n:occupation_6114')
  'occupation_6114',
  // t('backend-i18n:occupation_612')
  'occupation_612',
  // t('backend-i18n:occupation_6121')
  'occupation_6121',
  // t('backend-i18n:occupation_6122')
  'occupation_6122',
  // t('backend-i18n:occupation_6129')
  'occupation_6129',
  // t('backend-i18n:occupation_613')
  'occupation_613',
  // t('backend-i18n:occupation_6130')
  'occupation_6130',
  // t('backend-i18n:occupation_62')
  'occupation_62',
  // t('backend-i18n:occupation_621')
  'occupation_621',
  // t('backend-i18n:occupation_6210')
  'occupation_6210',
  // t('backend-i18n:occupation_622')
  'occupation_622',
  // t('backend-i18n:occupation_6221')
  'occupation_6221',
  // t('backend-i18n:occupation_6222')
  'occupation_6222',
  // t('backend-i18n:occupation_6223')
  'occupation_6223',
  // t('backend-i18n:occupation_63')
  'occupation_63',
  // t('backend-i18n:occupation_630')
  'occupation_630',
  // t('backend-i18n:occupation_6300')
  'occupation_6300',
  // t('backend-i18n:occupation_7')
  'occupation_7',
  // t('backend-i18n:occupation_71')
  'occupation_71',
  // t('backend-i18n:occupation_711')
  'occupation_711',
  // t('backend-i18n:occupation_7111')
  'occupation_7111',
  // t('backend-i18n:occupation_7112')
  'occupation_7112',
  // t('backend-i18n:occupation_7113')
  'occupation_7113',
  // t('backend-i18n:occupation_7114')
  'occupation_7114',
  // t('backend-i18n:occupation_7119')
  'occupation_7119',
  // t('backend-i18n:occupation_712')
  'occupation_712',
  // t('backend-i18n:occupation_7121')
  'occupation_7121',
  // t('backend-i18n:occupation_7122')
  'occupation_7122',
  // t('backend-i18n:occupation_7123')
  'occupation_7123',
  // t('backend-i18n:occupation_7124')
  'occupation_7124',
  // t('backend-i18n:occupation_7125')
  'occupation_7125',
  // t('backend-i18n:occupation_7126')
  'occupation_7126',
  // t('backend-i18n:occupation_713')
  'occupation_713',
  // t('backend-i18n:occupation_7131')
  'occupation_7131',
  // t('backend-i18n:occupation_7132')
  'occupation_7132',
  // t('backend-i18n:occupation_72')
  'occupation_72',
  // t('backend-i18n:occupation_721')
  'occupation_721',
  // t('backend-i18n:occupation_7211')
  'occupation_7211',
  // t('backend-i18n:occupation_7212')
  'occupation_7212',
  // t('backend-i18n:occupation_7213')
  'occupation_7213',
  // t('backend-i18n:occupation_7214')
  'occupation_7214',
  // t('backend-i18n:occupation_7215')
  'occupation_7215',
  // t('backend-i18n:occupation_722')
  'occupation_722',
  // t('backend-i18n:occupation_7221')
  'occupation_7221',
  // t('backend-i18n:occupation_7222')
  'occupation_7222',
  // t('backend-i18n:occupation_7223')
  'occupation_7223',
  // t('backend-i18n:occupation_7224')
  'occupation_7224',
  // t('backend-i18n:occupation_723')
  'occupation_723',
  // t('backend-i18n:occupation_7231')
  'occupation_7231',
  // t('backend-i18n:occupation_7232')
  'occupation_7232',
  // t('backend-i18n:occupation_7233')
  'occupation_7233',
  // t('backend-i18n:occupation_7234')
  'occupation_7234',
  // t('backend-i18n:occupation_73')
  'occupation_73',
  // t('backend-i18n:occupation_731')
  'occupation_731',
  // t('backend-i18n:occupation_7311')
  'occupation_7311',
  // t('backend-i18n:occupation_7312')
  'occupation_7312',
  // t('backend-i18n:occupation_7313')
  'occupation_7313',
  // t('backend-i18n:occupation_7314')
  'occupation_7314',
  // t('backend-i18n:occupation_7315')
  'occupation_7315',
  // t('backend-i18n:occupation_732')
  'occupation_732',
  // t('backend-i18n:occupation_7321')
  'occupation_7321',
  // t('backend-i18n:occupation_7322')
  'occupation_7322',
  // t('backend-i18n:occupation_7323')
  'occupation_7323',
  // t('backend-i18n:occupation_74')
  'occupation_74',
  // t('backend-i18n:occupation_741')
  'occupation_741',
  // t('backend-i18n:occupation_7411')
  'occupation_7411',
  // t('backend-i18n:occupation_7412')
  'occupation_7412',
  // t('backend-i18n:occupation_7413')
  'occupation_7413',
  // t('backend-i18n:occupation_742')
  'occupation_742',
  // t('backend-i18n:occupation_7421')
  'occupation_7421',
  // t('backend-i18n:occupation_7422')
  'occupation_7422',
  // t('backend-i18n:occupation_75')
  'occupation_75',
  // t('backend-i18n:occupation_751')
  'occupation_751',
  // t('backend-i18n:occupation_7511')
  'occupation_7511',
  // t('backend-i18n:occupation_7512')
  'occupation_7512',
  // t('backend-i18n:occupation_7513')
  'occupation_7513',
  // t('backend-i18n:occupation_7514')
  'occupation_7514',
  // t('backend-i18n:occupation_7515')
  'occupation_7515',
  // t('backend-i18n:occupation_7516')
  'occupation_7516',
  // t('backend-i18n:occupation_752')
  'occupation_752',
  // t('backend-i18n:occupation_7521')
  'occupation_7521',
  // t('backend-i18n:occupation_7522')
  'occupation_7522',
  // t('backend-i18n:occupation_753')
  'occupation_753',
  // t('backend-i18n:occupation_7531')
  'occupation_7531',
  // t('backend-i18n:occupation_7532')
  'occupation_7532',
  // t('backend-i18n:occupation_7533')
  'occupation_7533',
  // t('backend-i18n:occupation_7534')
  'occupation_7534',
  // t('backend-i18n:occupation_7535')
  'occupation_7535',
  // t('backend-i18n:occupation_7536')
  'occupation_7536',
  // t('backend-i18n:occupation_754')
  'occupation_754',
  // t('backend-i18n:occupation_7541')
  'occupation_7541',
  // t('backend-i18n:occupation_7542')
  'occupation_7542',
  // t('backend-i18n:occupation_7543')
  'occupation_7543',
  // t('backend-i18n:occupation_7544')
  'occupation_7544',
  // t('backend-i18n:occupation_7549')
  'occupation_7549',
  // t('backend-i18n:occupation_8')
  'occupation_8',
  // t('backend-i18n:occupation_81')
  'occupation_81',
  // t('backend-i18n:occupation_811')
  'occupation_811',
  // t('backend-i18n:occupation_8111')
  'occupation_8111',
  // t('backend-i18n:occupation_8112')
  'occupation_8112',
  // t('backend-i18n:occupation_8113')
  'occupation_8113',
  // t('backend-i18n:occupation_812')
  'occupation_812',
  // t('backend-i18n:occupation_8121')
  'occupation_8121',
  // t('backend-i18n:occupation_8122')
  'occupation_8122',
  // t('backend-i18n:occupation_8123')
  'occupation_8123',
  // t('backend-i18n:occupation_8124')
  'occupation_8124',
  // t('backend-i18n:occupation_8125')
  'occupation_8125',
  // t('backend-i18n:occupation_813')
  'occupation_813',
  // t('backend-i18n:occupation_8131')
  'occupation_8131',
  // t('backend-i18n:occupation_8132')
  'occupation_8132',
  // t('backend-i18n:occupation_814')
  'occupation_814',
  // t('backend-i18n:occupation_8141')
  'occupation_8141',
  // t('backend-i18n:occupation_8142')
  'occupation_8142',
  // t('backend-i18n:occupation_8143')
  'occupation_8143',
  // t('backend-i18n:occupation_8144')
  'occupation_8144',
  // t('backend-i18n:occupation_815')
  'occupation_815',
  // t('backend-i18n:occupation_8151')
  'occupation_8151',
  // t('backend-i18n:occupation_8152')
  'occupation_8152',
  // t('backend-i18n:occupation_8153')
  'occupation_8153',
  // t('backend-i18n:occupation_8154')
  'occupation_8154',
  // t('backend-i18n:occupation_8155')
  'occupation_8155',
  // t('backend-i18n:occupation_8156')
  'occupation_8156',
  // t('backend-i18n:occupation_8157')
  'occupation_8157',
  // t('backend-i18n:occupation_8159')
  'occupation_8159',
  // t('backend-i18n:occupation_816')
  'occupation_816',
  // t('backend-i18n:occupation_8160')
  'occupation_8160',
  // t('backend-i18n:occupation_817')
  'occupation_817',
  // t('backend-i18n:occupation_8171')
  'occupation_8171',
  // t('backend-i18n:occupation_8172')
  'occupation_8172',
  // t('backend-i18n:occupation_818')
  'occupation_818',
  // t('backend-i18n:occupation_8181')
  'occupation_8181',
  // t('backend-i18n:occupation_8182')
  'occupation_8182',
  // t('backend-i18n:occupation_8183')
  'occupation_8183',
  // t('backend-i18n:occupation_8189')
  'occupation_8189',
  // t('backend-i18n:occupation_82')
  'occupation_82',
  // t('backend-i18n:occupation_821')
  'occupation_821',
  // t('backend-i18n:occupation_8211')
  'occupation_8211',
  // t('backend-i18n:occupation_8212')
  'occupation_8212',
  // t('backend-i18n:occupation_8219')
  'occupation_8219',
  // t('backend-i18n:occupation_83')
  'occupation_83',
  // t('backend-i18n:occupation_831')
  'occupation_831',
  // t('backend-i18n:occupation_8311')
  'occupation_8311',
  // t('backend-i18n:occupation_8312')
  'occupation_8312',
  // t('backend-i18n:occupation_832')
  'occupation_832',
  // t('backend-i18n:occupation_8321')
  'occupation_8321',
  // t('backend-i18n:occupation_8322')
  'occupation_8322',
  // t('backend-i18n:occupation_8323')
  'occupation_8323',
  // t('backend-i18n:occupation_8324')
  'occupation_8324',
  // t('backend-i18n:occupation_833')
  'occupation_833',
  // t('backend-i18n:occupation_8331')
  'occupation_8331',
  // t('backend-i18n:occupation_8332')
  'occupation_8332',
  // t('backend-i18n:occupation_8333')
  'occupation_8333',
  // t('backend-i18n:occupation_8334')
  'occupation_8334',
  // t('backend-i18n:occupation_834')
  'occupation_834',
  // t('backend-i18n:occupation_8340')
  'occupation_8340',
  // t('backend-i18n:occupation_9')
  'occupation_9',
  // t('backend-i18n:occupation_91')
  'occupation_91',
  // t('backend-i18n:occupation_911')
  'occupation_911',
  // t('backend-i18n:occupation_9111')
  'occupation_9111',
  // t('backend-i18n:occupation_9112')
  'occupation_9112',
  // t('backend-i18n:occupation_912')
  'occupation_912',
  // t('backend-i18n:occupation_9121')
  'occupation_9121',
  // t('backend-i18n:occupation_9122')
  'occupation_9122',
  // t('backend-i18n:occupation_9123')
  'occupation_9123',
  // t('backend-i18n:occupation_9129')
  'occupation_9129',
  // t('backend-i18n:occupation_92')
  'occupation_92',
  // t('backend-i18n:occupation_921')
  'occupation_921',
  // t('backend-i18n:occupation_9211')
  'occupation_9211',
  // t('backend-i18n:occupation_9212')
  'occupation_9212',
  // t('backend-i18n:occupation_9213')
  'occupation_9213',
  // t('backend-i18n:occupation_9214')
  'occupation_9214',
  // t('backend-i18n:occupation_9215')
  'occupation_9215',
  // t('backend-i18n:occupation_93')
  'occupation_93',
  // t('backend-i18n:occupation_931')
  'occupation_931',
  // t('backend-i18n:occupation_9311')
  'occupation_9311',
  // t('backend-i18n:occupation_9312')
  'occupation_9312',
  // t('backend-i18n:occupation_9313')
  'occupation_9313',
  // t('backend-i18n:occupation_932')
  'occupation_932',
  // t('backend-i18n:occupation_9321')
  'occupation_9321',
  // t('backend-i18n:occupation_9329')
  'occupation_9329',
  // t('backend-i18n:occupation_933')
  'occupation_933',
  // t('backend-i18n:occupation_9331')
  'occupation_9331',
  // t('backend-i18n:occupation_9332')
  'occupation_9332',
  // t('backend-i18n:occupation_9333')
  'occupation_9333',
  // t('backend-i18n:occupation_9334')
  'occupation_9334',
  // t('backend-i18n:occupation_94')
  'occupation_94',
  // t('backend-i18n:occupation_941')
  'occupation_941',
  // t('backend-i18n:occupation_9411')
  'occupation_9411',
  // t('backend-i18n:occupation_9412')
  'occupation_9412',
  // t('backend-i18n:occupation_95')
  'occupation_95',
  // t('backend-i18n:occupation_951')
  'occupation_951',
  // t('backend-i18n:occupation_9510')
  'occupation_9510',
  // t('backend-i18n:occupation_96')
  'occupation_96',
  // t('backend-i18n:occupation_961')
  'occupation_961',
  // t('backend-i18n:occupation_9611')
  'occupation_9611',
  // t('backend-i18n:occupation_9612')
  'occupation_9612',
  // t('backend-i18n:occupation_9613')
  'occupation_9613',
  // t('backend-i18n:occupation_962')
  'occupation_962',
  // t('backend-i18n:occupation_9621')
  'occupation_9621',
  // t('backend-i18n:occupation_9622')
  'occupation_9622',
  // t('backend-i18n:occupation_9623')
  'occupation_9623',
  // t('backend-i18n:occupation_9624')
  'occupation_9624',
  // t('backend-i18n:occupation_9629')
  'occupation_9629',
  // t('backend-i18n:orderList')
  'orderList',
  // t('backend-i18n:patientParameter')
  'patientParameter',
  // t('backend-i18n:pending')
  'pending',
  // t('backend-i18n:pendingReview')
  'pendingReview',
  // t('backend-i18n:pendingReviewAndSignature')
  'pendingReviewAndSignature',
  // t('backend-i18n:pendingSignature')
  'pendingSignature',
  // t('backend-i18n:perinealIrrigation_done')
  'perinealIrrigation_done',
  // t('backend-i18n:perinealIrrigation_notDone')
  'perinealIrrigation_notDone',
  // t('backend-i18n:published')
  'published',
  // t('backend-i18n:publishedDraft')
  'publishedDraft',
  // t('backend-i18n:relationship_ADOPTF')
  'relationship_ADOPTF',
  // t('backend-i18n:relationship_ADOPTM')
  'relationship_ADOPTM',
  // t('backend-i18n:relationship_ADOPTP')
  'relationship_ADOPTP',
  // t('backend-i18n:relationship_AUNT')
  'relationship_AUNT',
  // t('backend-i18n:relationship_BRO')
  'relationship_BRO',
  // t('backend-i18n:relationship_BROINLAW')
  'relationship_BROINLAW',
  // t('backend-i18n:relationship_C')
  'relationship_C',
  // t('backend-i18n:relationship_CHILD')
  'relationship_CHILD',
  // t('backend-i18n:relationship_CHLDADOPT')
  'relationship_CHLDADOPT',
  // t('backend-i18n:relationship_CHLDFOST')
  'relationship_CHLDFOST',
  // t('backend-i18n:relationship_CHLDINLAW')
  'relationship_CHLDINLAW',
  // t('backend-i18n:relationship_COUSN')
  'relationship_COUSN',
  // t('backend-i18n:relationship_DAU')
  'relationship_DAU',
  // t('backend-i18n:relationship_DAUADOPT')
  'relationship_DAUADOPT',
  // t('backend-i18n:relationship_DAUC')
  'relationship_DAUC',
  // t('backend-i18n:relationship_DAUFOST')
  'relationship_DAUFOST',
  // t('backend-i18n:relationship_DAUINLAW')
  'relationship_DAUINLAW',
  // t('backend-i18n:relationship_DOMPART')
  'relationship_DOMPART',
  // t('backend-i18n:relationship_E')
  'relationship_E',
  // t('backend-i18n:relationship_EXT')
  'relationship_EXT',
  // t('backend-i18n:relationship_F')
  'relationship_F',
  // t('backend-i18n:relationship_FAMMEMB')
  'relationship_FAMMEMB',
  // t('backend-i18n:relationship_FMRSPS')
  'relationship_FMRSPS',
  // t('backend-i18n:relationship_FRND')
  'relationship_FRND',
  // t('backend-i18n:relationship_FTH')
  'relationship_FTH',
  // t('backend-i18n:relationship_FTHFOST')
  'relationship_FTHFOST',
  // t('backend-i18n:relationship_FTHINLAW')
  'relationship_FTHINLAW',
  // t('backend-i18n:relationship_FTWIN')
  'relationship_FTWIN',
  // t('backend-i18n:relationship_FTWINBRO')
  'relationship_FTWINBRO',
  // t('backend-i18n:relationship_FTWINSIS')
  'relationship_FTWINSIS',
  // t('backend-i18n:relationship_GESTM')
  'relationship_GESTM',
  // t('backend-i18n:relationship_GGRFTH')
  'relationship_GGRFTH',
  // t('backend-i18n:relationship_GGRMTH')
  'relationship_GGRMTH',
  // t('backend-i18n:relationship_GGRPRN')
  'relationship_GGRPRN',
  // t('backend-i18n:relationship_GRFTH')
  'relationship_GRFTH',
  // t('backend-i18n:relationship_GRMTH')
  'relationship_GRMTH',
  // t('backend-i18n:relationship_GRNDCHILD')
  'relationship_GRNDCHILD',
  // t('backend-i18n:relationship_GRNDDAU')
  'relationship_GRNDDAU',
  // t('backend-i18n:relationship_GRNDSON')
  'relationship_GRNDSON',
  // t('backend-i18n:relationship_GRPRN')
  'relationship_GRPRN',
  // t('backend-i18n:relationship_HBRO')
  'relationship_HBRO',
  // t('backend-i18n:relationship_HSIB')
  'relationship_HSIB',
  // t('backend-i18n:relationship_HSIS')
  'relationship_HSIS',
  // t('backend-i18n:relationship_HUSB')
  'relationship_HUSB',
  // t('backend-i18n:relationship_I')
  'relationship_I',
  // t('backend-i18n:relationship_INLAW')
  'relationship_INLAW',
  // t('backend-i18n:relationship_ITWIN')
  'relationship_ITWIN',
  // t('backend-i18n:relationship_ITWINBRO')
  'relationship_ITWINBRO',
  // t('backend-i18n:relationship_ITWINSIS')
  'relationship_ITWINSIS',
  // t('backend-i18n:relationship_MAUNT')
  'relationship_MAUNT',
  // t('backend-i18n:relationship_MCOUSN')
  'relationship_MCOUSN',
  // t('backend-i18n:relationship_MGGRFTH')
  'relationship_MGGRFTH',
  // t('backend-i18n:relationship_MGGRMTH')
  'relationship_MGGRMTH',
  // t('backend-i18n:relationship_MGGRPRN')
  'relationship_MGGRPRN',
  // t('backend-i18n:relationship_MGRFTH')
  'relationship_MGRFTH',
  // t('backend-i18n:relationship_MGRMTH')
  'relationship_MGRMTH',
  // t('backend-i18n:relationship_MGRPRN')
  'relationship_MGRPRN',
  // t('backend-i18n:relationship_MTH')
  'relationship_MTH',
  // t('backend-i18n:relationship_MTHFOST')
  'relationship_MTHFOST',
  // t('backend-i18n:relationship_MTHINLAW')
  'relationship_MTHINLAW',
  // t('backend-i18n:relationship_MUNCLE')
  'relationship_MUNCLE',
  // t('backend-i18n:relationship_N')
  'relationship_N',
  // t('backend-i18n:relationship_NBOR')
  'relationship_NBOR',
  // t('backend-i18n:relationship_NBRO')
  'relationship_NBRO',
  // t('backend-i18n:relationship_NCHILD')
  'relationship_NCHILD',
  // t('backend-i18n:relationship_NEPHEW')
  'relationship_NEPHEW',
  // t('backend-i18n:relationship_NFTH')
  'relationship_NFTH',
  // t('backend-i18n:relationship_NFTHF')
  'relationship_NFTHF',
  // t('backend-i18n:relationship_NIECE')
  'relationship_NIECE',
  // t('backend-i18n:relationship_NIENEPH')
  'relationship_NIENEPH',
  // t('backend-i18n:relationship_NMTH')
  'relationship_NMTH',
  // t('backend-i18n:relationship_NMTHF')
  'relationship_NMTHF',
  // t('backend-i18n:relationship_NPRN')
  'relationship_NPRN',
  // t('backend-i18n:relationship_NSIB')
  'relationship_NSIB',
  // t('backend-i18n:relationship_NSIS')
  'relationship_NSIS',
  // t('backend-i18n:relationship_O')
  'relationship_O',
  // t('backend-i18n:relationship_ONESELF')
  'relationship_ONESELF',
  // t('backend-i18n:relationship_PAUNT')
  'relationship_PAUNT',
  // t('backend-i18n:relationship_PCOUSN')
  'relationship_PCOUSN',
  // t('backend-i18n:relationship_PGGRFTH')
  'relationship_PGGRFTH',
  // t('backend-i18n:relationship_PGGRMTH')
  'relationship_PGGRMTH',
  // t('backend-i18n:relationship_PGGRPRN')
  'relationship_PGGRPRN',
  // t('backend-i18n:relationship_PGRFTH')
  'relationship_PGRFTH',
  // t('backend-i18n:relationship_PGRMTH')
  'relationship_PGRMTH',
  // t('backend-i18n:relationship_PGRPRN')
  'relationship_PGRPRN',
  // t('backend-i18n:relationship_PRN')
  'relationship_PRN',
  // t('backend-i18n:relationship_PRNFOST')
  'relationship_PRNFOST',
  // t('backend-i18n:relationship_PRNINLAW')
  'relationship_PRNINLAW',
  // t('backend-i18n:relationship_PUNCLE')
  'relationship_PUNCLE',
  // t('backend-i18n:relationship_ROOM')
  'relationship_ROOM',
  // t('backend-i18n:relationship_S')
  'relationship_S',
  // t('backend-i18n:relationship_SIB')
  'relationship_SIB',
  // t('backend-i18n:relationship_SIBINLAW')
  'relationship_SIBINLAW',
  // t('backend-i18n:relationship_SIGOTHR')
  'relationship_SIGOTHR',
  // t('backend-i18n:relationship_SIS')
  'relationship_SIS',
  // t('backend-i18n:relationship_SISINLAW')
  'relationship_SISINLAW',
  // t('backend-i18n:relationship_SON')
  'relationship_SON',
  // t('backend-i18n:relationship_SONADOPT')
  'relationship_SONADOPT',
  // t('backend-i18n:relationship_SONC')
  'relationship_SONC',
  // t('backend-i18n:relationship_SONFOST')
  'relationship_SONFOST',
  // t('backend-i18n:relationship_SONINLAW')
  'relationship_SONINLAW',
  // t('backend-i18n:relationship_SPS')
  'relationship_SPS',
  // t('backend-i18n:relationship_STPBRO')
  'relationship_STPBRO',
  // t('backend-i18n:relationship_STPCHLD')
  'relationship_STPCHLD',
  // t('backend-i18n:relationship_STPDAU')
  'relationship_STPDAU',
  // t('backend-i18n:relationship_STPFTH')
  'relationship_STPFTH',
  // t('backend-i18n:relationship_STPMTH')
  'relationship_STPMTH',
  // t('backend-i18n:relationship_STPPRN')
  'relationship_STPPRN',
  // t('backend-i18n:relationship_STPSIB')
  'relationship_STPSIB',
  // t('backend-i18n:relationship_STPSIS')
  'relationship_STPSIS',
  // t('backend-i18n:relationship_STPSON')
  'relationship_STPSON',
  // t('backend-i18n:relationship_TWIN')
  'relationship_TWIN',
  // t('backend-i18n:relationship_TWINBRO')
  'relationship_TWINBRO',
  // t('backend-i18n:relationship_TWINSIS')
  'relationship_TWINSIS',
  // t('backend-i18n:relationship_U')
  'relationship_U',
  // t('backend-i18n:relationship_UNCLE')
  'relationship_UNCLE',
  // t('backend-i18n:relationship_WIFE')
  'relationship_WIFE',
  // t('backend-i18n:religion_BHA')
  'religion_BHA',
  // t('backend-i18n:religion_BUD')
  'religion_BUD',
  // t('backend-i18n:religion_CAT')
  'religion_CAT',
  // t('backend-i18n:religion_CHR')
  'religion_CHR',
  // t('backend-i18n:religion_IKT')
  'religion_IKT',
  // t('backend-i18n:religion_ISL')
  'religion_ISL',
  // t('backend-i18n:religion_JUD')
  'religion_JUD',
  // t('backend-i18n:religion_LC')
  'religion_LC',
  // t('backend-i18n:religion_LDS')
  'religion_LDS',
  // t('backend-i18n:religion_MLD')
  'religion_MLD',
  // t('backend-i18n:religion_ORT')
  'religion_ORT',
  // t('backend-i18n:religion_OTH')
  'religion_OTH',
  // t('backend-i18n:religion_SCI')
  'religion_SCI',
  // t('backend-i18n:religion_SKG')
  'religion_SKG',
  // t('backend-i18n:religion_SYJ')
  'religion_SYJ',
  // t('backend-i18n:religion_TAO')
  'religion_TAO',
  // t('backend-i18n:religion_TD')
  'religion_TD',
  // t('backend-i18n:religion_TDC')
  'religion_TDC',
  // t('backend-i18n:religion_TDS')
  'religion_TDS',
  // t('backend-i18n:religion_TLJ')
  'religion_TLJ',
  // t('backend-i18n:religion_UC')
  'religion_UC',
  // t('backend-i18n:religion_XTJ')
  'religion_XTJ',
  // t('backend-i18n:religion_XYC')
  'religion_XYC',
  // t('backend-i18n:reportCategory_AU')
  'reportCategory_AU',
  // t('backend-i18n:reportCategory_BG')
  'reportCategory_BG',
  // t('backend-i18n:reportCategory_BLB')
  'reportCategory_BLB',
  // t('backend-i18n:reportCategory_CG')
  'reportCategory_CG',
  // t('backend-i18n:reportCategory_CH')
  'reportCategory_CH',
  // t('backend-i18n:reportCategory_CP')
  'reportCategory_CP',
  // t('backend-i18n:reportCategory_CT')
  'reportCategory_CT',
  // t('backend-i18n:reportCategory_CTH')
  'reportCategory_CTH',
  // t('backend-i18n:reportCategory_CUS')
  'reportCategory_CUS',
  // t('backend-i18n:reportCategory_EC')
  'reportCategory_EC',
  // t('backend-i18n:reportCategory_EN')
  'reportCategory_EN',
  // t('backend-i18n:reportCategory_GE')
  'reportCategory_GE',
  // t('backend-i18n:reportCategory_HM')
  'reportCategory_HM',
  // t('backend-i18n:reportCategory_ICU')
  'reportCategory_ICU',
  // t('backend-i18n:reportCategory_IMM')
  'reportCategory_IMM',
  // t('backend-i18n:reportCategory_LAB')
  'reportCategory_LAB',
  // t('backend-i18n:reportCategory_MB')
  'reportCategory_MB',
  // t('backend-i18n:reportCategory_MCB')
  'reportCategory_MCB',
  // t('backend-i18n:reportCategory_MYC')
  'reportCategory_MYC',
  // t('backend-i18n:reportCategory_NMR')
  'reportCategory_NMR',
  // t('backend-i18n:reportCategory_NMS')
  'reportCategory_NMS',
  // t('backend-i18n:reportCategory_NRS')
  'reportCategory_NRS',
  // t('backend-i18n:reportCategory_OSL')
  'reportCategory_OSL',
  // t('backend-i18n:reportCategory_OT')
  'reportCategory_OT',
  // t('backend-i18n:reportCategory_OTH')
  'reportCategory_OTH',
  // t('backend-i18n:reportCategory_OUS')
  'reportCategory_OUS',
  // t('backend-i18n:reportCategory_PF')
  'reportCategory_PF',
  // t('backend-i18n:reportCategory_PHR')
  'reportCategory_PHR',
  // t('backend-i18n:reportCategory_PHY')
  'reportCategory_PHY',
  // t('backend-i18n:reportCategory_PT')
  'reportCategory_PT',
  // t('backend-i18n:reportCategory_RAD')
  'reportCategory_RAD',
  // t('backend-i18n:reportCategory_RC')
  'reportCategory_RC',
  // t('backend-i18n:reportCategory_RT')
  'reportCategory_RT',
  // t('backend-i18n:reportCategory_RUS')
  'reportCategory_RUS',
  // t('backend-i18n:reportCategory_RX')
  'reportCategory_RX',
  // t('backend-i18n:reportCategory_SP')
  'reportCategory_SP',
  // t('backend-i18n:reportCategory_SR')
  'reportCategory_SR',
  // t('backend-i18n:reportCategory_TX')
  'reportCategory_TX',
  // t('backend-i18n:reportCategory_VR')
  'reportCategory_VR',
  // t('backend-i18n:reportCategory_VUS')
  'reportCategory_VUS',
  // t('backend-i18n:reportCategory_XRC')
  'reportCategory_XRC',
  // t('backend-i18n:secondEmergencyContact')
  'secondEmergencyContact',
  // t('backend-i18n:signed')
  'signed',
  // t('backend-i18n:smart_form_uncategorized')
  'smart_form_uncategorized',
  // t('backend-i18n:systemParameter')
  'systemParameter',
  // t('backend-i18n:uncategorized')
  'uncategorized',
  // t('backend-i18n:uterineFirmness_firm')
  'uterineFirmness_firm',
  // t('backend-i18n:uterineFirmness_soft')
  'uterineFirmness_soft',
  // t('backend-i18n:woundCondition_cleanGood')
  'woundCondition_cleanGood',
  // t('backend-i18n:woundCondition_edema')
  'woundCondition_edema',
  // t('backend-i18n:woundCondition_exudate')
  'woundCondition_exudate',
  // t('backend-i18n:woundCondition_redness')
  'woundCondition_redness',
  // t('backend-i18n:woundType_abd')
  'woundType_abd',
  // t('backend-i18n:woundType_ep')
  'woundType_ep'
] as const;

export type BackendI18nCode = (typeof BACKEND_I18N_CODES)[number];
